import React from 'react';
import PropTypes from 'prop-types';

import styles from './column-text.scss';

const ColumnText = ({ headline, children, dark }) => (
  <div className={dark ? styles.primaryBackgroundText : styles.columnText}>
    <div className={styles.textInner}>
      <h2>{headline}</h2>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  </div>
);

ColumnText.propTypes = {
  headline: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  dark: PropTypes.bool,
};

ColumnText.defaultProps = {
  dark: false,
};

export default ColumnText;



// WEBPACK FOOTER //
// ./blocks/ColumnText/index.js